import { Controller, Control, FieldError, FieldPath, FieldValues } from 'react-hook-form';
import { Label, FormText, FormGroup, Input } from 'reactstrap';
import type { InputType } from 'reactstrap/lib/Input';

interface FormInputProps<TFieldValues extends FieldValues> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    label?: string;
    id?: string;
    placeholder?: string;
    type?: InputType;
    size?: 'sm' | 'lg';
    disabled?: boolean;
    error?: FieldError;
    helperText?: string;
}

export const FormInput = <TFieldValues extends FieldValues>({
    name,
    control,
    label,
    id,
    placeholder,
    type = 'text',
    size,
    disabled,
    error,
    helperText,
}: FormInputProps<TFieldValues>) => (
    <FormGroup>
        {label && <Label for={id ?? name}>{label}</Label>}
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <Input
                    {...field}
                    id={id ?? name}
                    type={type}
                    bsSize={size}
                    placeholder={placeholder}
                    disabled={disabled}
                    value={field.value ?? ''}
                />
            )}
        />
        {helperText && <FormText>{helperText}</FormText>}
        {error && <FormText color="danger">{error.message}</FormText>}
    </FormGroup>
);
